/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { postData } from '../../util/index'
import { GETCLUBREVENUE } from './constants'

export const getClubRevenue = (payload) => {
  return {
    type: GETCLUBREVENUE,
    payload,
  }
}

//营收报表
export function fetchClubRevenue(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/RevenueReport`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubRevenue(data))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRevenue/action.js